// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React, { Component } from "react";
import ReactDOM from "react-dom";
import CookieValue from "../utils/cookie_value";
import Cookies from "universal-cookie";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import DropdownSettings from "../components/settings/DropdownSettings";
import SignUp from "../components/sessions/SignUp";
import Login from "../components/sessions/Login";
import TestComponent from "../components/TestComponent";
import LandingPage from "../components/landing_page/LandingPageMainContainer";
import HomeMainContainer from "../components/home/HomeMainContainer";
import SyllabusIndexMainContainer from "../components/syllabi/index/SyllabiIndexMainContainer";
import SyllabiShowMainContainer from "../components/syllabi/show/SyllabiShowMainContainer";
import EventsIndexMainContainer from "../components/events/index/EventsIndexMainContainer";
import EventShowMainContainer from "../components/events/show/EventShowMainContainer";
import UsersIndexMainContainer from "../components/users/index/UsersIndexMainContainer";
import UserShowMainContainer from "../components/users/show/UserShowMainContainer";
import UpdatePasswordMainContainer from "../components/users/show/UpdatePasswordMainContainer";
import UpdatePasswordFromToken from "../components/users/UpdatePasswordFromToken";
import ForgotPwContainer from "../components/users/ForgotPwContainer";
import Navbar from "../components/Navbar";
import Notice from "../components/Notice";
import Footer from "../components/Footer";
import Logout from "../components/sessions/Logout";

class AppStart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timedOut: false,
      loggedIn: false,
      full_name: "",
      univ_lookup: {},
      role_lookup: {},
      id: null,
      notice_message: "",
      display_error: false,
      _isMounted: false,
      country_authorizer: "",
      pwd_reset_req: false,
    };
    this.cookies = new Cookies();
  }

  componentDidMount() {
    this._isMounted = true;
    this.setLoggedInUser();
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this._isMounted) {
      /** load initial data for container whenit initially mounts **/
      if (this.state.loggedIn == true && prevState.loggedIn == false) {
        this.setLoggedInUser();
      }
      if (this.state.timedOut === true) {
        this.setState({ timedOut: false });
      }
    }
  }

  setLoggedInUser = () => {
    if (CookieValue()) {
      this.whoami()
        .then((data) => {
          let state = data;
          state["loggedIn"] = true;
          if (this._isMounted) {
            console.log("SET LOGGED IN", state);
            this.setState(state);
          }
        })
        .catch((err) => {
          if (this._isMounted) {
            console.log("should auto logout");
            this.cookies.remove("user_session", { path: "/" });
            this.setLoggedOutState();
            this.setState({
              timedOut: true,
              notice_message: err,
              display_error: true,
            });
          }
        });
    }
  };

  /**
   * TO DO: call whenever user visits a new url without
   * triggering the component
   **/
  handleChangedRoute = () => {
    this.setState({
      display_error: true,
      notice_message: "",
    });
  };

  setLoggedInState = () => {
    this.setState({
      loggedIn: true,
    });
  };

  setLoggedOutState = () => {
    this.setState({
      loggedIn: false,
      full_name: "",
      univ_lookup: {},
      role_lookup: {},
      id: null,
    });
  };

  whoami = () => {
    const state = this.state;
    const { id } = state;
    return new Promise((resolve, reject) => {
      if (id == null && this._isMounted) {
        console.log("ASK WHOAMI WITH STATE", state);
        const url = process.env.API_URL + "whoami";
        try {
          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Bearer " + CookieValue(),
            },
          }).then((res) => {
            if (res.status == 500) {
              reject("Error: Session timed out.");
            } else if (res.status == 401) {
              reject("Error: Unauthorized user account.");
            } else {
              res.json().then((data) => {
                resolve(data);
              });
            } /**no error 500 in res.status**/
          });
        } catch (err) {
          reject(err);
        }
      } else {
        console.log("ALREADY KNOW WHOAMI");
        resolve(state);
        console.log("IS STATE SET? ", state);
      }
    });
  };

  render() {
    const {
      loggedIn,
      full_name,
      role_lookup,
      id,
      notice_message,
      display_error,
      country_authorizer,
      pwd_reset_token,
      pwd_reset_req,
    } = this.state;
    const userRole = role_lookup ? role_lookup.name : null;
    const DropdownSettingsPg = (props) => {
      return <DropdownSettings {...props} userRole={userRole} userId={id} />;
    };
    const UsersIndex = (props) => {
      return (
        <UsersIndexMainContainer {...props} userRole={userRole} userId={id} />
      );
    };
    const UserShowEdit = (props) => {
      return (
        <UserShowMainContainer
          {...props}
          currentUserRole={userRole}
          currentUserId={id}
          country_authorizer={country_authorizer}
        />
      );
    };
    const UpdatePassword = (props) => {
      return (
        <UpdatePasswordMainContainer
          {...props}
          currentUserRole={userRole}
          currentUserId={id}
        />
      );
    };
    const SyllabiIndex = (props) => {
      return (
        <SyllabusIndexMainContainer
          {...props}
          userRole={userRole}
          userId={id}
        />
      );
    };
    const SyllabusShowEdit = (props) => {
      return (
        <SyllabiShowMainContainer {...props} userRole={userRole} userId={id} />
      );
    };
    const EventsIndex = (props) => {
      return (
        <EventsIndexMainContainer
          {...props}
          userRole={userRole}
          currentUserId={id}
        />
      );
    };
    const EventShowEdit = (props) => {
      return <EventShowMainContainer {...props} currentUserId={id} />;
    };
    const LoginForm = (props) => {
      return <Login {...props} toggleLoggedInState={this.setLoggedInState} />;
    };
    const UpdateFromToken = (props) => {
      return (
        <UpdatePasswordFromToken
          {...props}
          toggleLoggedInState={this.setLoggedInState}
        />
      );
    };
    const authorized_routes = (
      <Switch>
        <Route path="/test_component" component={TestComponent} />
        <Route path="/log_in" component={LoginForm} />
        <Route path="/sign_up" component={SignUp} />
        <Route path="/forgot_pw" component={ForgotPwContainer} />
        <Route
          path="/reset_pw/:userId/:pwResetToken"
          component={UpdateFromToken}
        />
        <Route path="/syllabi" render={SyllabiIndex} />
        <Route path="/syllabus/:syllabusId" render={SyllabusShowEdit} />
        <Route path="/events" render={EventsIndex} />
        <Route path="/event/:eventId" render={EventShowEdit} />
        <Route path="/users" render={UsersIndex} />
        <Route path="/user/:userId" render={UserShowEdit} />
        <Route path="/changepw/:userId" render={UpdatePassword} />
        <Route path="/dropdown_settings" render={DropdownSettingsPg} />
        <Route path="/logout">
          <Logout setLoggedOutState={this.setLoggedOutState} />
        </Route>
        <Route exact path="/">
          <HomeMainContainer />
        </Route>
      </Switch>
    );
    const unauthorized_routes = (
      <Switch>
        <Route path="/log_in" component={LoginForm} />
        <Route path="/sign_up" component={SignUp} />
        <Route path="/forgot_pw" component={ForgotPwContainer} />
        <Route
          path="/reset_pw/:userId/:pwResetToken"
          component={UpdateFromToken}
        />
        <Route>
          <LandingPage />
        </Route>
      </Switch>
    );

    const force_password_reset = (
      <Route>
        <UpdatePasswordMainContainer
          {...this.props}
          currentUserRole={userRole}
          currentUserId={id}
          redirectOnSuccess={true}
        />
      </Route>
    );

    const current_routes = () => {
      if (!CookieValue()) {
        return unauthorized_routes;
      } else if (pwd_reset_req) {
        return force_password_reset;
      }
      return authorized_routes;
    };

    return (
      <Router>
        <Navbar
          loggedIn={loggedIn}
          userName={full_name}
          userRole={userRole}
          userId={id}
        />
        <Notice
          display_error={display_error}
          display_notice={false}
          notice_message={notice_message}
        />
        {current_routes()}
        <Footer />
      </Router>
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  //
  ReactDOM.render(
    <AppStart />,
    document.body.appendChild(document.createElement("div"))
  );
});
